import { render, staticRenderFns } from "./MapRegions.vue?vue&type=template&id=45586ec1&scoped=true&"
import script from "./MapRegions.vue?vue&type=script&lang=js&"
export * from "./MapRegions.vue?vue&type=script&lang=js&"
import style0 from "./MapRegions.vue?vue&type=style&index=0&id=45586ec1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45586ec1",
  null
  
)

export default component.exports